import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { RUOLI, STATO_TASK, formatDate } from "@/lib/constants";
import { AppShell } from "@/components/layout/AppShell";
import { RoleBadge } from "@/components/Badges";
import { useAuth } from "@/context/AuthContext";

const COLS = ["da_fare", "in_corso", "completato"];

export default function TaskBoard() {
  const { user } = useAuth();
  const [tasks, setTasks] = useState([]);
  const [ruolo, setRuolo] = useState(user?.role === "admin" ? "" : user?.role || "");
  const [mine, setMine] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { api.get("/tasks", { params: { ...(ruolo ? { ruolo } : {}), ...(mine ? { mine: true } : {}) } }).then((r) => setTasks(r.data)); }, [ruolo, mine]);

  const move = async (t, stato) => {
    const { data } = await api.patch(`/tasks/${t.id}`, { stato });
    setTasks(tasks.map((x) => (x.id === t.id ? { ...x, ...data } : x)));
  };

  return (
    <AppShell title="Bacheca task" subtitle="Tutte le attività del team, filtrabili per professionalità"
      actions={<>
        <label className="inline-flex items-center gap-2 text-sm text-slate-700 cursor-pointer"><input type="checkbox" checked={mine} onChange={(e) => setMine(e.target.checked)} className="h-4 w-4 accent-[#003087]" data-testid="taskboard-mine-toggle" /> Solo i miei</label>
        <select value={ruolo} onChange={(e) => setRuolo(e.target.value)} className="h-9 rounded-md border border-slate-200 bg-white px-3 text-sm" data-testid="taskboard-role-filter">
          <option value="">Tutti i ruoli</option>
          {Object.entries(RUOLI).filter(([k]) => k !== "admin").map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
        </select>
      </>}>
      <div className="grid md:grid-cols-3 gap-6" data-testid="taskboard">
        {COLS.map((col) => {
          const list = tasks.filter((t) => t.stato === col);
          return (
            <div key={col} className="bg-slate-100/70 border border-slate-200 rounded-xl p-4 min-h-[300px]" data-testid={`taskboard-col-${col}`}
              onDragOver={(e) => e.preventDefault()} onDrop={(e) => { const t = tasks.find((x) => x.id === e.dataTransfer.getData("id")); if (t && t.stato !== col) move(t, col); }}>
              <div className="flex items-center justify-between mb-4">
                <span className={`rounded-full px-2.5 py-0.5 text-xs font-medium ${STATO_TASK[col].cls}`}>{STATO_TASK[col].label}</span>
                <span className="text-xs text-slate-500">{list.length}</span>
              </div>
              <div className="space-y-3">
                {list.map((t) => (
                  <div key={t.id} draggable onDragStart={(e) => e.dataTransfer.setData("id", t.id)} data-testid={`taskboard-card-${t.id}`}
                    className="bg-white border border-slate-200 rounded-lg p-4 cursor-grab active:cursor-grabbing transition-transform duration-200 hover:-translate-y-0.5 hover:shadow-md">
                    <p className="text-sm text-slate-900 leading-snug">{t.titolo}</p>
                    <button onClick={() => navigate(`/pratiche/${t.pratica_id}`)} className="text-xs text-[#003087] hover:underline mt-1.5 block text-left">{t.pratica_titolo}</button>
                    <div className="flex items-center justify-between mt-3">
                      <RoleBadge role={t.ruolo} />
                      <span className="text-[11px] text-slate-500">{t.scadenza ? formatDate(t.scadenza) : ""}</span>
                    </div>
                    <div className="flex gap-1 mt-3">
                      {COLS.filter((c) => c !== col).map((c) => (
                        <button key={c} onClick={() => move(t, c)} className="text-[11px] px-2 py-1 rounded-md bg-slate-50 border border-slate-200 text-slate-600 hover:bg-slate-100 transition-colors" data-testid={`taskboard-move-${t.id}-${c}`}>→ {STATO_TASK[c].label}</button>
                      ))}
                    </div>
                  </div>
                ))}
                {list.length === 0 && <p className="text-xs text-slate-400 text-center py-8">Nessun task</p>}
              </div>
            </div>
          );
        })}
      </div>
    </AppShell>
  );
}
